module.exports = __webpack_public_path__ + "img/Mage-undead-m-70.e25821f1.gif";